export const mathCal = (n: number, multiply: number) => {
  const FloatVal: string = multiply.toFixed(1);

  if (n > 0) return Math.ceil(n / Number(FloatVal)) * multiply;
  else if (n < 0) return Math.floor(n / Number(FloatVal)) * multiply;
  else return multiply;
};

export const clampNumber = (number: number, min: number, max: number) => {
  return Math.min(Math.max(number, min), max);
};

export const sortAsc = (a, b) => {
  if (!a?.name || !b?.name) return 0;
  if (a?.name < b?.name) return -1;
  if (a?.name > b?.name) return 1;
  return 0;
};
